// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VehicleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/VehicleConstants.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../fare-estimate-v1/domain/store/FareEstimateStoreV1.mjs";
import * as FareEstimateResultStoreEn$PorterinFeature from "../../../../shared/core/constants/FareEstimateResultStoreEn.mjs";

function showDivider(faqs, link_section, content_title) {
  if (link_section.length > 0 && content_title.length > 0) {
    return true;
  } else {
    return faqs.length > 0;
  }
}

function serviceStringToType(service) {
  if (service === VehicleConstants$PorterinUtils.twoWheelerKebabCase || service === VehicleConstants$PorterinUtils.courier) {
    return /* TwoWheelers */0;
  } else if (service === VehicleConstants$PorterinUtils.trucks) {
    return /* Trucks */4;
  } else if (service === VehicleConstants$PorterinUtils.compact) {
    return /* Compact */5;
  } else if (service === FareEstimateResultStoreEn$PorterinFeature.service_category_partload) {
    return /* Partload */8;
  } else {
    return /* Trucks */4;
  }
}

function stringToServiceCategory(service) {
  if (service === VehicleConstants$PorterinUtils.twoWheelerKebabCase || service === VehicleConstants$PorterinUtils.courier) {
    return FareEstimateResultStoreEn$PorterinFeature.service_category_two_wheelers;
  } else if (service === VehicleConstants$PorterinUtils.trucks) {
    return FareEstimateResultStoreEn$PorterinFeature.service_category_trucks;
  } else if (service === VehicleConstants$PorterinUtils.compact) {
    return FareEstimateResultStoreEn$PorterinFeature.service_category_compact;
  } else if (service === VehicleConstants$PorterinUtils.partload) {
    return FareEstimateResultStoreEn$PorterinFeature.service_category_partload;
  } else {
    return FareEstimateResultStoreEn$PorterinFeature.service_category_trucks;
  }
}

function serviceCategoryToString(service) {
  if (service !== 0) {
    if (service >= 8) {
      return VehicleConstants$PorterinUtils.partload;
    } else {
      return VehicleConstants$PorterinUtils.trucks;
    }
  } else {
    return VehicleConstants$PorterinUtils.twoWheelerShort;
  }
}

function serviceCategoryToGAString(service) {
  if (service !== 0) {
    if (service >= 8) {
      return FareEstimateStoreV1$PorterinFeature.partloadCategoryGA;
    } else {
      return FareEstimateStoreV1$PorterinFeature.trucksCategoryGA;
    }
  } else {
    return FareEstimateStoreV1$PorterinFeature.twowheeletCategoryGA;
  }
}

export {
  showDivider ,
  serviceStringToType ,
  stringToServiceCategory ,
  serviceCategoryToString ,
  serviceCategoryToGAString ,
}
/* FareEstimateStoreV1-PorterinFeature Not a pure module */
